import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        path: '/',
        name: 'Main',
        beforeEnter: () => {

            location.href = '/main.html';
        }
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/router/views/Home'), // 동적 import
        children: [
            // #region 회사소개
            // 회사소개 > 소개
            {
                path: '/company/intro',
                name: 'Intro',
                component: () => import('@/router/views/company/Intro'),
            },
            // 회사소개 > 인재상
            {
                path: '/company/talent',
                name: 'Talent',
                component: () => import('@/router/views/company/Talent'),
            },
            // #endregion

            // #region 채용공고
            // 채용공고 > 채용공고
            {
                path: '/recruit/careers',
                name: 'Careers',
                component: () => import('@/router/views/recruit/Careers'),
            },
            // 채용공고 > 채용공고 > 상세보기
            {
                path: '/recruit/careers-view',
                name: 'CareersView',
                component: () => import('@/router/views/recruit/CareersView'),
            },
            // 채용공고 > 상시채용
            {
                path: '/recruit/always-recruite',
                name: 'AlwaysRecruite',
                component: () => import('@/router/views/recruit/AlwaysRecruite'),
            },
            // 채용공고 > 상시채용 > 상세보기
            {
                path: '/recruit/always-recruite-view',
                name: 'AlwaysRecruiteView',
                component: () => import('@/router/views/recruit/AlwaysRecruiteView'),
            },
            // 채용공고 > 공지사항
            {
                path: '/recruit/notice',
                name: 'Notice',
                component: () => import('@/router/views/recruit/Notice'),
            },
            // 채용공고 > 공지사항 > 상세보기
            {
                path: '/recruit/notice-view',
                name: 'NoticeView',
                component: () => import('@/router/views/recruit/NoticeView'),
            },
            // 채용공고 > 채용FAQ
            {
                path: '/recruit/faq',
                name: 'Faq',
                component: () => import('@/router/views/recruit/Faq'),
            },
            // #endregion

            // #region 나의 지원정보
            {
                path: '/information/report',
                name: 'Report',
                component: () => import('@/router/views/information/Report'),
            },
            // 지원서 조회/수정 상세
            {
                path: '/information/report-detail',
                name: 'ReportDetail',
                component: () => import('@/router/views/information/ReportDetail'),
            },
            // 지원서 조회(최종제출 후)
            {
                path: '/information/show-enroll',
                name: 'ShowEnroll',
                component: () => import('@/router/views/information/ShowEnroll'),
            },
            {
                path: '/information/confirm-notice',
                name: 'ConfirmNotice',
                component: () => import('@/router/views/information/ConfirmNotice'),
            },
            {
                path: '/information/confirm-notice-detail',
                name: 'ConfirmNoticeDetail',
                component: () => import('@/router/views/information/ConfirmNoticeDetail'),
            },
            {
                path: '/information/pass',
                name: 'Pass',
                component: () => import('@/router/views/information/Pass'),
            },
            // 나의 지원정보 > 채용공고 > 인증
            {
                path: '/recruit/apply',
                name: 'Apply',
                component: () => import('@/router/views/recruit/Apply'),
            },
            // 나의 지원정보 > 채용공고 > 실명인증
            {
                path: '/recruit/apply-edit',
                name: 'ApplyEdit',
                component: () => import('@/router/views/recruit/ApplyEdit'),
            },
            // 나의 지원정보 > 채용공고 > 이력서 작성, 수정(기본, 병역, 학력)
            {
                path: '/recruit/enroll-application',
                name: 'EnrollApplication',
                component: () => import('@/router/views/recruit/EnrollApplication'),
            },
            // 나의 지원정보 > 채용공고 > 이력서 작성, 수정(경력)
            {
                path: '/recruit/input-careers',
                name: 'InputCareers',
                component: () => import('@/router/views/recruit/InputCareers'),
            },
            // 나의 지원정보 > 채용공고 > 이력서 작성, 수정 (외국어,자격증,첨부파일)
            {
                path: '/recruit/enroll-application2',
                name: 'EnrollApplication2',
                component: () => import('@/router/views/recruit/EnrollApplication2'),
            },
            // 나의 지원정보 > 채용공고 > 이력서 작성, 수정(자기소개서 등록)
            {
                path: '/recruit/interview',
                name: 'Interview',
                component: () => import('@/router/views/recruit/Interview'),
            },
            // 나의 지원정보 > 채용공고 > 이력서 작성, 수정(최종제출)
            {
                path: '/recruit/confirm-application',
                name: 'ConfirmApplication',
                component: () => import('@/router/views/recruit/ConfirmApplication'),
            },
            // 나의 지원정보 > 채용공고 > 이력서작성완료
            {
                path: '/recruit/welcome',
                name: 'Welcome',
                component: () => import('@/router/views/recruit/Welcome'),
            },
            // #endregion 

            // #region 이용안내
            // 이용안내 > 이메일주소 무단수집거부
            {
                path: '/guide/persnal-information',
                name: 'PersnalInformation',
                component: () => import('@/router/views/guide/PersnalInformation'),
            },
            // #endregion
        ]
    },
];

const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
});

export default router;
